import { useState } from 'react'
import Input from '../../../../shared/components/form/input'
import Button from '../../../../shared/components/Button/Button'
import Modal from '../../../../shared/modal/Modal'
import FormLayout from '../../../../shared/components/FormLayout/FormLayout'


function FormRecordNextByUser({title,data, closeModal, handleOnSubmit}) {
    const [newRecord, setNewRecord] = useState(data || "")

    function handleChange(e) {
        setNewRecord({...newRecord, [e.target.name]: e.target.value})
    }
    async function submit(){

       handleOnSubmit(newRecord)
    }


    return (
        <Modal
            modalStatus={true}
            changeStatus={closeModal}
            w={38}
            h={42}
            content={
                <FormLayout requiredLegend
                    title={title}
                    actions={
                        <>
                            <Button variant="save" onClick={() => { submit() }}>Salvar</Button>
                            <Button variant="cancel" onClick={closeModal}>Cancelar</Button>
                        </>
                    }
                >
                    <Input
                        type="month"
                        name="date"
                        required text="Registro - Mês e Ano"
                        handleOnChange={handleChange}
                        value={newRecord.date || ""}
                    />

                    <Input
                        type="month"
                        name="nextDate"
                        text="Próximo a ser Realizada - Mês e Ano"
                        handleOnChange={handleChange}
                        value={newRecord.nextDate || ""}
                    />
                </FormLayout>
            }
        />
    )
}

export default FormRecordNextByUser
